import * as types from "../../mutation-types";
import ProductsIngredientsProvider from "../../../providers/ProductsIngredientsProvider";

// initial state
const state = {
	productsIngredientsFiltered:[],
	allProductsIngredients: []
};

// getters
const getters = {
	productsIngredients: state => state.productsIngredientsFiltered,
	allProductsIngredients: state => state.allProductsIngredients
};

// actions
const actions = {
	// ingredients
	refreshProductsIngredients({commit}, {ingredientId, type}) {
		return readAllProductsIngredients(commit, ingredientId, type);
	},
	/*eslint-disable*/
	createNewProductIngredient: ({dispatch, getters}, productIngredient) => {
		return ProductsIngredientsProvider.createNewProductIngredient(productIngredient, getters.jwtToken).then(()=>{
		});
	},
	deleteProductIngredient: ({dispatch, getters}, productIngredient) => {
		return ProductsIngredientsProvider.deleteProductIngredient(productIngredient, getters.jwtToken).then(()=>{
		});
	}
};

/*
	Begining of a zone with a helper functions
 */

// export function for external use
export function readAllProductsIngredients(commit, ingredientId, type="BY_INGREDIENT_ID"){

	switch (type) {
	case "BY_INGREDIENT_ID":
		return ProductsIngredientsProvider.getProductsIngredientsByIngredientId(ingredientId)
			.then(productsIngredients => {
				return commit(types.REFRESH_PRODUCTS_INGREDIENTS, productsIngredients);
			})
			.catch(() => {
			});
	case "BY_PRODUCT_ID":
		return ProductsIngredientsProvider.getProductsIngredientsByProductId(ingredientId)
			.then(productsIngredients => {
				return commit(types.REFRESH_PRODUCTS_INGREDIENTS, productsIngredients);
			})
			.catch(() => {
			});
	case "GET_ALL":
		return ProductsIngredientsProvider.getAllProductsIngredients()
			.then(productsIngredients => {
				return commit(types.CACHE_ALL_PRODUCTS_INGREDIENTS, productsIngredients);
			})
			.catch(() => {
			});
	default:
		return ProductsIngredientsProvider.getProductsIngredientsByIngredientId(ingredientId)
			.then(productsIngredients => {
				return commit(types.REFRESH_PRODUCTS_INGREDIENTS, productsIngredients);
			})
			.catch(() => {
			});
	}

}
/*
	End of a zone with a helper functions
 */

// mutations
const mutations = {
	[types.REFRESH_PRODUCTS_INGREDIENTS](state, productsIngredients){
		const receivedArray = productsIngredients.productsIngredients.data.slice();
		state.productsIngredientsFiltered = receivedArray;
	},
	[types.CACHE_ALL_PRODUCTS_INGREDIENTS](state, productsIngredients){
		const receivedArray = productsIngredients.productsIngredients.data.slice();
		state.allProductsIngredients = receivedArray;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
